(function () {
  var KEY = 'srMotionSound';
  function getPref() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
  function setPref(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var players = [], GEST = ['pointerup', 'touchend', 'click', 'keydown'];
  var pageReady = false, readyQ = [], WAKE = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
  function wake() {
    if (pageReady) return;
    pageReady = true;
    WAKE.forEach(function (t) { window.removeEventListener(t, wake, true); });
    var q = readyQ.splice(0); for (var i = 0; i < q.length; i++) q[i]();
  }
  WAKE.forEach(function (t) { window.addEventListener(t, wake, { capture: true, passive: true }); });
  function whenReady(f) { if (pageReady) f(); else readyQ.push(f); }
  var conn = navigator.connection, lowData = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  var films = [];
  function soloOthers(v) { for (var i = 0; i < films.length; i++) { var o = films[i]; if (o !== v && !o.paused) { o.pause(); } if (o !== v) o.muted = true; } }
  function gesture() {
    var ua = navigator.userActivation;
    if (ua && !ua.isActive) return;
    for (var i = 0; i < players.length; i++) players[i]();
  }
  function disarm() { GEST.forEach(function (t) { document.removeEventListener(t, gesture, true); }); }
  GEST.forEach(function (t) { document.addEventListener(t, gesture, true); });

  var Z = null;
  function css() {
    if (document.getElementById('srm-css')) return;
    var st = document.createElement('style'); st.id = 'srm-css';
    st.textContent =
      '[data-sr-motion] video{cursor:zoom-in!important}' +
      '.srm-expand{position:absolute!important;top:10px!important;left:10px!important;width:34px!important;height:34px!important;min-width:0!important;padding:0!important;margin:0!important;border:0!important;border-radius:999px!important;background:rgba(28,38,57,.72)!important;color:#fff!important;display:grid!important;place-items:center!important;cursor:pointer!important;z-index:2!important;box-shadow:none!important}' +
      '.srm-expand svg{width:18px!important;height:18px!important}' +
      '.srm-expand:focus-visible{outline:2px solid #F58220!important;outline-offset:2px!important}' +
      '#srm-zoom#srm-zoom{position:fixed!important;inset:0!important;z-index:2147483000!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:16px!important;margin:0!important;background:rgba(10,14,22,.86)!important;box-sizing:border-box!important}' +
      '#srm-zoom#srm-zoom[hidden]{display:none!important}' +
      '#srm-zoom .srm-zbox{position:relative!important;width:min(1200px,100%)!important;max-height:100%!important;margin:0!important;padding:0!important}' +
      '#srm-zoom video{display:block!important;width:100%!important;height:auto!important;max-height:calc(100vh - 96px)!important;max-width:100%!important;object-fit:contain!important;border-radius:14px!important;background:#000!important;margin:0 auto!important;cursor:default!important}' +
      '#srm-zoom .srm-zbar{display:flex!important;justify-content:flex-end!important;gap:8px!important;margin:0 0 10px!important;padding:0!important}' +
      '#srm-zoom button{width:40px!important;height:40px!important;min-width:0!important;padding:0!important;margin:0!important;border:0!important;border-radius:999px!important;background:rgba(255,255,255,.16)!important;color:#fff!important;display:grid!important;place-items:center!important;cursor:pointer!important;box-shadow:none!important}' +
      '#srm-zoom button:hover{background:rgba(255,255,255,.28)!important}' +
      '#srm-zoom button:focus-visible{outline:2px solid #F58220!important;outline-offset:2px!important}' +
      '#srm-zoom button svg{width:20px!important;height:20px!important}' +
      'html.srm-noscroll,html.srm-noscroll body{overflow:hidden!important}';
    document.head.appendChild(st);
  }
  var ICON_FULL = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
  function zoomer() {
    if (Z) return Z;
    var el = document.createElement('div');
    el.id = 'srm-zoom'; el.hidden = true;
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-label', 'Video');
    el.innerHTML = '<div class="srm-zbox"><div class="srm-zbar">' +
      '<button type="button" data-z-full aria-label="Full screen">' + ICON_FULL + '</button>' +
      '<button type="button" data-z-close aria-label="Close video"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '</div><video playsinline loop controls controlslist="nodownload noplaybackrate" disablepictureinpicture></video></div>';
    document.body.appendChild(el);
    var zv = el.querySelector('video');
    Z = { el: el, v: zv, from: null, back: null };
    function close() {
      if (el.hidden) return;
      var src = Z.from;
      el.hidden = true; document.documentElement.classList.remove('srm-noscroll');
      if (document.fullscreenElement && document.exitFullscreen) document.exitFullscreen().catch(function () {});
      var t = zv.currentTime, m = zv.muted; zv.pause();
      if (src) { try { src.v.currentTime = t; } catch (e) {} src.resume(!m); }
      if (Z.back && Z.back.focus) Z.back.focus();
    }
    Z.close = close;
    el.addEventListener('click', function (e) { if (e.target === el) close(); });
    el.querySelector('[data-z-close]').addEventListener('click', close);
    el.querySelector('[data-z-full]').addEventListener('click', function () {
      if (zv.requestFullscreen) zv.requestFullscreen().catch(function () {});
      else if (zv.webkitEnterFullscreen) zv.webkitEnterFullscreen();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) close(); });
    return Z;
  }
  function openZoom(p) {
    var z = zoomer();
    z.from = p; z.back = document.activeElement;
    z.v.src = p.v.currentSrc || p.v.getAttribute('data-src');
    z.v.poster = p.v.poster || '';
    var t = p.v.currentTime || 0;
    p.v.pause();
    z.el.hidden = false; document.documentElement.classList.add('srm-noscroll');
    z.v.muted = getPref() === 'off';
    try { z.v.currentTime = t; } catch (e) {}
    var q = z.v.play(); if (q && q.catch) q.catch(function () { z.v.muted = true; z.v.play().catch(function () {}); });
    z.el.querySelector('[data-z-close]').focus();
  }

  function init(box) {
    if (box.__srm) return;
    var skip = box.getAttribute('data-skip-params');
    if (skip && window.URLSearchParams) {
      var q = new URLSearchParams(location.search), ks = skip.split(',');
      for (var i = 0; i < ks.length; i++) if (ks[i].trim() && q.has(ks[i].trim())) { box.__srm = 1; box.hidden = true; return; }
    }
    var anchor = box.getAttribute('data-anchor');
    var a = anchor && document.querySelector(anchor);
    box.__srm = 1;
    if (anchor && !a) {
      var done = false, mo = new MutationObserver(function () {
        var f = document.querySelector(anchor);
        if (f && !done) { done = true; mo.disconnect(); f.parentNode.insertBefore(box, f.nextSibling); setup(box); }
      });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { if (!done) { done = true; mo.disconnect(); setup(box); } }, 8000);
      return;
    }
    if (a && a.parentNode) a.parentNode.insertBefore(box, a.nextSibling);
    setup(box);
  }

  function setup(box) {
    box.hidden = false;
    var v = box.querySelector('video'), ctl = box.querySelector('[data-motion-ctl]');
    var bSound = box.querySelector('[data-sound]'), bPause = box.querySelector('[data-pause]'), bHide = box.querySelector('[data-hide]');
    var paused = reduced || lowData, loaded = false, inView = false;

    function load() { if (!loaded) { v.src = v.getAttribute('data-src'); loaded = true; } }
    function showSound(on) {
      if (!bSound) return;
      bSound.setAttribute('aria-pressed', on ? 'true' : 'false');
      var l = bSound.querySelector('[data-sound-label]'); if (l) l.textContent = on ? 'Sound off' : 'Sound on';
      var w = bSound.querySelector('[data-i="waves"]'), m = bSound.querySelector('[data-i="mute"]');
      if (w) w.hidden = !on; if (m) m.hidden = on;
    }
    function showPaused(x) {
      if (!bPause) return;
      bPause.setAttribute('aria-label', x ? 'Play animation' : 'Pause animation');
      bPause.querySelector('[data-i="pause"]').hidden = x; bPause.querySelector('[data-i="play"]').hidden = !x;
    }
    function play(withSound, restartWhenSound) {
      load();
      soloOthers(v);
      v.muted = !withSound;
      var p = v.play();
      if (p && p.then) {
        p.then(function () {
          if (!v.muted) { disarm(); if (restartWhenSound) { try { v.currentTime = 0; } catch (e) {} } }
          showSound(!v.muted);
        }).catch(function () {
          if (!v.muted) { v.muted = true; showSound(false); var q = v.play(); if (q && q.catch) q.catch(function () {}); }
        });
      } else showSound(!v.muted);
    }
    function zoomOpen() { return Z && !Z.el.hidden; }
    function start() { if (!zoomOpen()) play(getPref() !== 'off'); }
    players.push(function () {
      if (paused || !inView || zoomOpen() || getPref() === 'off' || !v.muted) return;
      play(true, true);
    });

    if (ctl) ctl.hidden = false;
    showPaused(paused); showSound(false);
    css();
    var me = { v: v, resume: function (withSound) { if (!paused) play(withSound); } };
    films.push(v);
    var holder = v.parentNode;
    if (getComputedStyle(holder).position === 'static') holder.style.setProperty('position', 'relative', 'important');
    var ex = document.createElement('button');
    ex.type = 'button'; ex.className = 'srm-expand'; ex.setAttribute('aria-label', 'Watch larger');
    ex.innerHTML = ICON_FULL;
    holder.appendChild(ex);
    function zoom(e) { if (e) e.preventDefault(); load(); openZoom(me); }
    ex.addEventListener('click', zoom);
    v.addEventListener('click', zoom);
    if (bPause) bPause.addEventListener('click', function () {
      paused = !paused; showPaused(paused);
      if (paused) v.pause(); else start();
    });
    if (bSound) bSound.addEventListener('click', function () {
      if (v.muted || v.paused) {
        setPref('on'); paused = false; showPaused(false);
        load(); try { v.currentTime = 0; } catch (e) {}
        play(true);
      } else { setPref('off'); v.muted = true; showSound(false); }
    });
    if (bHide) bHide.addEventListener('click', function () {
      paused = true; v.pause(); box.hidden = true;
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          inView = e.isIntersecting;
          if (inView && !paused) whenReady(function () { if (inView && !paused) start(); }); else v.pause();
        });
      }, { threshold: 0.35 }).observe(v);
    } else { inView = true; if (!paused) whenReady(start); }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) v.pause(); else if (inView && !paused) start();
    });
  }

  function all() { var l = document.querySelectorAll('[data-sr-motion]'); for (var i = 0; i < l.length; i++) init(l[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.srMotionScan = all;
})();
